// extracted by mini-css-extract-plugin
export default {"outerContainer":"BXsEy3","sizing":"rB2c3f","double":"SU7fnE","imageContainer":"AO0uZW","image":"l9662k","imageBackground":"nqTF0G"};